/**
 * recommendation form
 */
import $ from 'jquery';

export const recommendationForm = () => {
    $('.ghwp-recommendation-form input[type="submit"]').on('click', function(e) {
        e.preventDefault();

        const form = $(this).closest('.ghwp-recommendation-form');
        const firstName = form.find('[name="ghwp-cf-vorname"]').val();
        const lastName = form.find('[name="ghwp-cf-nachname"]').val();
        const customerId = form.find('[name="ghwp-cf-kundennummer"]').val();

        if (firstName === '' || lastName === '' || customerId === '') {
            form.find('.ghwp-message-error').show();
            return;
        }
        form.find('.ghwp-message-error').hide();

        let recommendationText = window.recommendationText.replace(encodeURIComponent('#vorname#'), encodeURIComponent(firstName));
        recommendationText = recommendationText.replace(encodeURIComponent('#nachname#'), encodeURIComponent(lastName));
        recommendationText = recommendationText.replace(encodeURIComponent('#kundennummer#'), encodeURIComponent(customerId));

        window.location = 'mailto:?subject=' + window.recommendationSubject + '&body=' + recommendationText;
    });
};
